import { fetchCycleTimeTrend } from "../api/aiMetricsApi";
import { makeAdoMetricHook } from "./useAdoMetric";
import { ADO_QUERY_KEYS } from "./adoQueryKeys";

export const useAdoCycleTimeTrend = makeAdoMetricHook(
  ADO_QUERY_KEYS.cycleTimeTrend,
  fetchCycleTimeTrend,
);
